<template>
    <div>
        <div v-if="editable">
            <b-form-radio-group v-if="!preloadError"
                :id="id"
                v-model="modelValue"
                :options="options"
                :key="options.length"
                :name="name + '-radio-options'"
                @change="onChange" stacked/>
            <span v-else class="text-danger">Ошибка загрузки вариантов выбора</span>
        </div>
        <div v-else>
            {{ getModelValueText() }}
        </div>
    </div>
</template>

<script>
import httpClient from "@/http";

export default {
    name: "RadioList",
    props: {
        id: {type: String},
        name: {type: String},
        url: {type: String},
        idKey: { type: String, default: 'id' },
        labelKey: { type: String, default: 'name' },
        editable: { type: Boolean, default: true },
        selectedObject: {}
    },
    model: {
        prop: 'selectedObject',
        event: 'selected-object-changed'
    },
    computed: {
        modelValue: {
            get: function () {
                return this.selectedObject
            },
            set: function (value) {
                this.$emit('selected-object-changed', value)
            }
        }
    },
    data() {
        return {
            options: [],
            preloadError: false,
            optionsData: {}
        }
    },
    methods: {
        onChange() {
            this.$emit('radio-changed', this.name, this.modelValue, this.optionsData[this.modelValue])
        },
        getModelValueText() {
            for (const option of this.options) {
                if (option.value === this.modelValue) {
                    return option.text
                }
            }
            return '—'
        }
    },
    mounted() {
        const vm = this;
        vm.preloadError = false;
        httpClient.get(this.url).then(response => {
            const results = response.data['results'];
            if (results && results.length > 0) {
                for (const entry of results) {
                    const option = {
                        text: entry[vm.labelKey],
                        value: entry[vm.idKey],
                    };
                    vm.options.push(option);
                    vm.optionsData[entry[vm.idKey]] = entry;
                }
            }
        }).catch(reason => { vm.preloadError = true })
    }
}
</script>

<style scoped>

</style>